// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ids-block-grid-item img {
  margin-block-end: var(--ids-block-grid-margin);
}

.ids-block-grid-wrapper {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: var(--ids-space-none);
  text-align: center;
}

:host(.ids-align-center) {
  text-align: center;
}

:host(.ids-align-left) {
  text-align: left;
}

:host(.ids-align-right) {
  text-align: right;
}

::slotted(ids-block-grid-item) {
  padding: var(--ids-block-grid-item-padding);
  position: relative;
  vertical-align: top;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-block-grid/ids-block-grid.scss"],"names":[],"mappings":"AACE;EACE,8CAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,6BAAA;EACA,kBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,2CAAA;EACA,kBAAA;EACA,mBAAA;AADF","sourcesContent":["ids-block-grid-item {\n  img {\n    margin-block-end: var(--ids-block-grid-margin);\n  }\n}\n\n.ids-block-grid-wrapper {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: var(--ids-space-none);\n  text-align: center;\n}\n\n:host(.ids-align-center) {\n  text-align: center;\n}\n\n:host(.ids-align-left) {\n  text-align: left;\n}\n\n:host(.ids-align-right) {\n  text-align: right;\n}\n\n::slotted(ids-block-grid-item) {\n  padding: var(--ids-block-grid-item-padding);\n  position: relative;\n  vertical-align: top;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
